








































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { RecommendationLetterStep } from '@/store/modules/entities/recommendation-letter.module';
import { Student } from '@/models/student/student';
import { recommendationLetterModule } from '@/store/modules/entities/recommendation-letter.module';

@Component
export default class GStudentRecordRecommendationLetterPolicySelectionStep extends Vue {
  @Prop({ required: true }) student!: Student;

  get targetInstitution(): string {
    return recommendationLetterModule.targetInstitution;
  }

  get recommendationGuidelines(): string {
    return recommendationLetterModule.recommendationGuidelines;
  }

  get admissionPolicy(): string {
    return recommendationLetterModule.admissionPolicy;
  }

  get achievements(): string {
    return recommendationLetterModule.achievements;
  }

  get mostSignificantAchievement(): string {
    return recommendationLetterModule.mostSignificantAchievement;
  }

  get motivationLetter(): string {
    return recommendationLetterModule.motivationLetter;
  }

  get personalityEpisode(): string {
    return recommendationLetterModule.personalityEpisode;
  }

  get desiredLength(): number {
    return recommendationLetterModule.desiredLength;
  }

  get temperature(): number {
    return recommendationLetterModule.temperature;
  }

  get generationPreferences(): string[] {
    return recommendationLetterModule.generationPreferences;
  }

  get selectedGenerationPreferences(): string[] {
    return recommendationLetterModule.selectedGenerationPreferences;
  }

  private readonly reverseTemperatureMap = new Map<number, number>([
    [0.2, 1],
    [0.8, 2],
    [1.0, 3],
    [1.3, 4],
    [1.8, 5],
  ]);

  get temperatureLabel(): number {
    const currentTemp = this.temperature;
    const closestKey = Array.from(this.reverseTemperatureMap.keys()).reduce((prev, curr) => {
      return Math.abs(curr - currentTemp) < Math.abs(prev - currentTemp) ? curr : prev;
    });
    return this.reverseTemperatureMap.get(closestKey) || 3;
  }

  activePreferenceClass = 'bg-blue-7 text-white';

  isPreferenceSelected(preference: string): boolean {
    return this.selectedGenerationPreferences.includes(preference);
  }

  handleGenerationPreferenceClick(preference: string) {
    recommendationLetterModule.toggleGenerationPreference(preference);
  }

  get preferenceButtonClass() {
    return (preference: string) => ({
      'wd-p-100': true,
      'rounded-4': true,
      'generation-preference-button': true,
      'border-blue-7': true,
      'fs-14': true,
      [this.activePreferenceClass]: this.isPreferenceSelected(preference),
      'text-blue-7': !this.isPreferenceSelected(preference),
      'bg-white': !this.isPreferenceSelected(preference),
    });
  }

  prevStep() {
    recommendationLetterModule.setCurrentStep(RecommendationLetterStep.StudentInfo);
  }

  async generateRecommendationLetter() {
    try {
      recommendationLetterModule.setLoadingText(this.$t('RECOMMENDATION_LETTER_GENERATE_LOADING').toString());
      await recommendationLetterModule.generateRecommendationLetter();
    } catch (error) {
      this.$Message.error(this.$t('RECOMMENDATION_LETTER_GENERATE_ERROR'));
    } finally {
      recommendationLetterModule.setLoadingText();
    }
  }

  get selectedGenerationPreferencesText(): string {
    return this.selectedGenerationPreferences.join(', ');
  }
}
